import SingleSelectField from "components/ui/single-select";
import { ActionButtons } from "../components/ActionButtons";
import { ScoreSection } from "./ScoreSection";

import VectorlineIcon from "assets/icons/Vectorline.svg?react";
import RightArrowIcon from "assets/icons/chevron-right.svg?react";

import { NavLink } from "react-router-dom";
import CactusSaddleIcon from "assets/icons/cactus_saddleIcon.svg?react";
import SaddleOutlineIcon from "assets/icons/saddleIcon.svg?react";
import SeatSizeIcon from "assets/icons/seat-size.svg?react";
import { FavoriteButton } from "../components/FavouriteBtn";
import { ImageGallery, BrandImageOverlay } from "./ImageGallery";
import { formatString, manufacturerListPath, isBillyCookBrandName } from "utils/index";
import { getBillyCookColorSelectProps } from "components/ui/BillyCookColorSelect";
import { formatDescription, formatPrice, formatProductTitle, saddleSelectStyles } from "../utils";

export const MobileView = ({
  navigate, filteredSaddle, favouriteList, handleFavourite, handleImageClick,
  user, control, seatSizes, colors, saddle, locationState, watch
}) => {
  const currentIndex = watch("currentIndex");
  const selectedHorseStatus = watch("selectedHorseStatus");
  const favouriteLoading = watch("favouriteLoading");
  const selectedHorse = watch("selectedHorse");
  const filteredScore = Math.round(filteredSaddle?.score);
  const filteredPrice = filteredSaddle?.price;
  const billyCookColorSelectProps = isBillyCookBrandName(filteredSaddle?.brandName)
    ? getBillyCookColorSelectProps("color", saddleSelectStyles)
    : null;

  return (
    <div className="py-32 lg:hidden">
      <div className="back_to_homepage_mobile" onClick={() => navigate(-1)}>
        <div className="flex items-center">
          <RightArrowIcon />
          <p>Back to Saddles</p>
        </div>
      </div>

      <div className="flex w-[90%] mx-auto mt-[40px] justify-between">
        <NavLink
          to={manufacturerListPath(filteredSaddle?.brandName)}
          className="text-[#5B7FB4] text-[24px] font-semibold leading-[110%] font-[Montserrat] cursor-pointer hover:underline"
        >
          {formatString(filteredSaddle?.brandName)}
        </NavLink>
        {filteredSaddle?.size && (
          <div className="seat_size_container">
            <p className="item_size !text-[10px] !leading-6">SEAT SIZE:</p>
            <SeatSizeIcon />
            <p className="item_size">{`${filteredSaddle?.size}"`}</p>
          </div>
        )}
      </div>

      <div className="flex items-center w-[90%] justify-between mx-auto flex-wrap">
        <h1 className="productTitle_mobile text-start flex items-center justify-center gap-x-[10px]">
          {formatProductTitle(filteredSaddle?.productTitle)}
          <div className="flex flex-row gap-2">
            {isBillyCookBrandName(filteredSaddle?.brandName) ? (
              <SaddleOutlineIcon className="w-[25px] h-[25px] mr-[2px]" />
            ) : (
              <CactusSaddleIcon className="w-[25px] h-[25px] mr-[2px]" />
            )}
          </div>
        </h1>

        <div className="mt-2 flex items-center justify-end w-full">
          <FavoriteButton
            user={user}
            saddle={filteredSaddle}
            favouriteList={favouriteList}
            favouriteLoading={favouriteLoading}
            handleFavourite={handleFavourite}
          />
        </div>
      </div>

      <ImageGallery 
        saddle={filteredSaddle}
        currentIndex={currentIndex}
        handleImageClick={handleImageClick}
        isMobile={true}
      />

      <div className="w-[90%] mx-auto hidden sm:flex justify-center gap-x-[30px] mt-[30px] h-full">
        <div className="flex flex-col justify-center items-center gap-y-[20px] h-full">
          {filteredSaddle?.gallery?.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`saddleimg${index + 1}`}
              className={`cursor-pointer ${
                index === currentIndex
                  ? "selected border-[#5C80B6] w-[85px] h-[85px] border-2 rounded-[10px]"
                  : "border-[#999] border rounded-[10px]"
              } hover:opacity-60 w-[85px] h-[85px] transition-opacity duration-200`}
              onClick={() => handleImageClick(index)}
            />
          ))}
        </div>

        <div className="relative">
          <img
            src={filteredSaddle?.gallery?.[currentIndex]}
            alt="saddle-imagess"
            className="max-w-[605.106px] w-full min-h-[601.744px]"
          />
          <BrandImageOverlay
            brandName={filteredSaddle?.brandName}
            className="w-[90px] h-[46px] absolute bottom-[7px] left-[6px]"
          />
        </div>
      </div>

      <div className="w-full sm:w-[100%] mx-auto">
        <div className="items-center w-[90%] mx-auto gap-x-2 mt-[30px]">
          <ScoreSection
            selectedHorseStatus={selectedHorseStatus}
            filteredScore={filteredScore}
            navigate={navigate}
          />
        </div>

        <div className="saddle_price mx-auto w-[90%]">
          <p className="text-[#343434] text-[24px] font-bold mt-3">
            ${formatPrice(filteredPrice)}
          </p>
        </div>

        <div className="sm:flex justify-between items-center w-[90%] mx-auto flex-wrap gap-x-4">
          {saddle?.type === "PRODUCT" && colors?.length > 0 && (
            <div className="mt-3 w-full sm:max-w-[223px] flex items-center justify-center">
              <SingleSelectField
                name="color"
                label="Color"
                placeholder="Select Color"
                height="40px"
                control={control}
                options={colors}
                className="saddle_details_dropdown_formInput"
                stylesOverride={
                  billyCookColorSelectProps?.stylesOverride ?? saddleSelectStyles
                }
                components={billyCookColorSelectProps?.components}
              />
            </div>
          )}

          {saddle?.type === "PRODUCT" && (
            <div className="mt-3 w-full sm:max-w-[223px] flex items-center justify-center">
              <SingleSelectField
                name="size"
                label="Seat Size"
                placeholder="Select Size"
                height="40px"
                control={control}
                options={seatSizes}
                className="saddle_details_dropdown_formInput"
                stylesOverride={saddleSelectStyles}
              />
            </div>
          )}

          <div className="sm:flex sm:justify-end sm:items-center w-full">
            <div className="saddle_report_mobile">
              <ActionButtons
                user={user}
                filteredSaddle={filteredSaddle}
                selectedHorse={selectedHorse}
                locationState={locationState}
                saddle={saddle}
                selectedHorseStatus={selectedHorseStatus}
                handleCheckAuth={() => {}}
                isMobile={true}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="vectorline_mobile">
        <VectorlineIcon />
      </div>

      <div className="w-[90%] mx-auto mt-[24px]">
        <p className="saddle_information">Saddle Information</p>
        <div
          className="text-gray-800 leading-relaxed space-y-4 saddle_paragraph"
          dangerouslySetInnerHTML={{ __html: formatDescription(filteredSaddle?.description) }}
        />
      </div>
    </div>
  );
};